import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import './App.css';
import HomeView from './views/HomeView/HomeView.js';
import BuildView from './views/BuildView/BuildView.js';
import LoginView from './views/LoginView/LoginView.js';
import TrainerView from './views/TrainerView/TrainerView.js';


const App = () => (
  <Router>

  <div>
      <Route exact path="/" component={Home} />
      <Route  path="/login/:id?" component={Login} />
      <Route path="/build/:id?" component={Build} />
      <Route exact path="/module/:id?/:article?" component={Trainer} />
  </div>

  </Router>
);


const Home = () => (
    <HomeView />
);
const Login = ({match}) => (
    <LoginView  tokenID={match.params.id}/>
);
const Trainer = ({ match }) => (
    <TrainerView moduleID={match.params.id}/>
);
const Build = ({ match }) => (
  <BuildView moduleID={match.params.id}/>
);




export default App;



// WEBPACK FOOTER //
// ./src/App.js